<template>
      <div id="wrapper">
            
            <topbar></topbar>
            <left></left>
      <div class="content-page">
            <!-- Start content -->
            <div class="content">
                  <div class="container-fluid">
                        
                        <div class="row">
                              <div class="col-12">
                                    <div class="page-title-box">
                                          <h4 class="page-title float-left">认证专区</h4>
      
                                          <ol class="breadcrumb float-right">
                                                <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                <li class="breadcrumb-item"><a href="#">认证专区</a></li>
                                                <li class="breadcrumb-item active">再认证</li>
                                          </ol>
                                          
                                          <div class="clearfix"></div>
                                    </div>
                              </div>
                        </div>
                        <!-- end row -->
                        
                        
                        <div class="row">
                              <div class="col-12">
                                    <div class="card-box">
                                          <div class="row">
                                                <div class="col-12">
                                                      <div class="p-20" >
                                                            
                                                            
                                                            <div class="form-group row" style="text-align:center;">
                                                                  <img src="t3.png"  width="100%">
                                                            </div>
      
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                                  您需要支付的会员费用为: <code style="font-size:16px !important; font-weight: bold">300元</code>
                                                            </p>
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                                  请选择付款方式
                                                            </p>
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:15px !important;" v-if="lockpay==true">
                                                                  <img src="/member2/images/alipay.png" width="200px"  v-on:click="baoming('alipay',orderid)">
                                                            </p>
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:15px !important;" v-if="lockpay==true">
                                                                  <img src="/member2/images/wechatpay.png" width="200px"   v-on:click="baoming('wechatpay',orderid)">
                                                            </p>
      
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                                  或者使用兑换码
                                                            </p>
                                                            <p class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:15px !important;">
                                                                  <input type="text" name="country"
                                                                         v-model="code"
                                                                         class="form-control"
                                                                         placeholder="请输入兑换码"
                                                                         style="max-width: 410px;margin-top: 10px;"
                                                                  >
                                                            </p>
                                                            <p  class="text-muted m-b-30 font-14" style="color: #000000 !important;margin-top:28px;font-size:17px !important;">
                                                                  <button type="submit" style="margin: 0 auto;"
                                                                          class="btn btn-gradient btn-rounded waves-light waves-effect w-md"
                                                                          v-on:click="freecode">提交兑换码
                                                                  </button>
                                                            </p>
                                                            <div style="clear: both"></div>
                                                      
                                                      
                                                      </div>
                                                </div>
                                          
                                          </div>
                                          <!-- end row -->
                                    
                                    </div> <!-- end card-box -->
                              </div><!-- end col -->
                        </div>
                        <!-- end row -->
                  
                  
                  </div> <!-- container -->
            
            </div> <!-- content -->
      
            <!--footer-->
      
      </div>

      </div>
</template>

<script>
      import topbar from './topbar';
      import left from './left';
      export default {
            name: 'signup',
            components:{topbar,left},
            data() {
                  return {
                        orderid:this.orderid,
                        lockpay:false,
                        code:this.code,
                  }
            },
            mounted(){
                  this.checkpower();
            },
            created(){
                  this.writeorder();
            },
            methods: {
                  checkpower: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/Authentication2_check',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if(response.data.code==1){
                                    window.location.href = '#/Authentication_show?key=' + response.data.msg;
                              }else if(response.data.code==2){
                                    window.location.href="#/Authentication_show?key=3";
                              }else if(response.data.code==3){
                                    window.location.href="#/Authentication_show?key=4";
                              }else if(response.data.code==4){
                                    //这里不弹框
                              }else if(response.data.code==5){
                                    //直接跳转到填写地址那里
                                    window.location.href="#/Authentication2_step4?out_trade_no="+response.data.orderid;
                              }else if(response.data.code==6){
                                    //直接跳转到填写地址那里
                                    window.location.href="#/Authentication2_step3";
                              }

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  writeorder: function () {
                        this.$axios({
                              method: "get",
                              url: '/api/member2/Authentication2_order_write',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if(response.data.code != 0){
                                    swal(
                                          {
                                                title: '请联系管理员',
                                                text: '',
                                                type: 'warning',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }else{
                                    this.orderid=response.data.orderid;
                                    this.lockpay=true;
                              }

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  baoming: function (paystyle,orderid) {
                        let data = {
                              paystyle: paystyle,
                              orderid:orderid,
                        }
                        this.$axios({
                              method: "POST",
                              url: '/api/member2/Authentication2_order',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if(response.status==200){
                                    if (response.data.code === 0) {
                                          // 0-alipay wechatpay
                                          if (response.data.paystyle === 'alipay') {
                                                //console.log(response.data.paystyle);
                                                window.location.href = '/api/member2/A2/pay/rz_alipay/' + response.data.orderid;
                                          } else if (response.data.paystyle === 'wechatpay') {
                                                if (this.isMobile()) {
                                                      this.wechatpay_h5(response.data.orderid);
                                                } else {
                                                      //this.wechatpay(response.data.arr.orderid);
                                                      window.location.href="/member2/#/Authentication2_step3_erweima?orderid="+response.data.orderid;
                                                }
                                                //this.isMobile();

                                          }
                                    }
                                    console.log(response.data.orderid);
                              }
                              

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  isMobile: function () {
                        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
                        console.log(flag);
                        return flag;
                  },
                 
                  wechatpay_h5: function (orderid) {
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/A2/pay/rz_wechatpay_h5/' + orderid
                        }).then(function onSuccess(response) {

                              if (response.data.code === 0) {
                                    window.location.href = response.data.mweburl;
                              }
                              console.log(response.data.code);

                        }.bind(this)).catch(function onError() {
                              alert('异常');
                        })
                  },
                  requestorderid: function () {
                        this.$axios({
                              method: 'get',
                              url: '/api/member2/Authentication2_order/'
                        }).then(function onSuccess(response) {

                              if (response.data.code === 0) {
                                    this.paylock=true;
                                    this.orderid=response.data.orderid
                              }

                        }.bind(this)).catch(function onError() {
                        
                        })
                  },
                  freecode:function () {
                        let data = {
                              orderid:this.orderid,
                              code:this.code,
                              money: 0,
                              paystyle: 'freecode',
                        }
                        this.$axios({
                              method: 'post',
                              data:data,
                              url: '/api/member2/pay/freecode_Authentication2/',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function onSuccess(response) {

                              if (response.data.code === 0) {
                                    window.location.href = '/member2/#/Authentication2_step4?out_trade_no=60a3d59bee54820210518105627';
                              }else{
                                    //alert(response.data.msg);
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'warning',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }

                        }.bind(this)).catch(function onError() {
                              alert('异常');
                        })
                  }
                 
                  
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}

  
     
</style>



// WEBPACK FOOTER //
// src/components/Authentication2_step3.vue